export const SET_ATTENDEES = 'events/SET_ATTENDEES';

/**
 * @param payload
 * @returns {{payload: *, type: string}}
 */
export const setAttendees = (payload) => ({ type: SET_ATTENDEES, payload });
